<template>
  <ContentSection
    spacing="none"
    :class="conditionalSpacing"
  >
    <Container indent="lg-but-on-mobile-default">
      <div
        v-if="data.text"
        v-animate-children-in-from-bottom
        class="br-wysiwyg"
        v-html="data.text"
      />
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import type { ComponentsBrBrTextFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsBrBrTextFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const conditionalSpacing = useConditionalSpacing(
  props.prevComponent,
  props.nextComponent,
)
</script>
